import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dropOrder, dropOrderImage, insertNewOrder, updateDeps, updateOrder } from './orderSlice';
import { addUser, dropUserDocument, setDeletingUser, updateUser } from './userSlice';
import { deleteRevenue, dropExpense, dropExpenses, setExpenses, setRevenues, updateBalances, updateExpense, updateExpenses, updateExpensesCategory } from './officeSlice';
import { addCategory, deleteCategory, editCategory, updateAvailableUsers } from './settingSlice';
import { dropImage } from './staticSlice';
import { pushAdditionalSpreadFlyers, pushFinishedRoute, pushPromoter, setAddressChecked, setPorchChecked, setPromoterDeleted, setPromoterRecovered, setRouteChecked, setRouteFinished, setRouteReadyToCheck, updateFinishedRoute, updatePromoter, updateRoute, updateRouteLocks, updateRouteProgress, updateRouteStarted } from './advertSlice';

const initialState = {
    list: []
};

const NOTIFY_TIMEOUT = 10000;
const SSE_NOTIFY_TIMEOUT = 60000;


//HTTP

//SSE
export const SERVER_NOTS = {
    CREATE_ORDER: 'CREATE_ORDER',
    CREATE_ORDER_DEP: 'CREATE_ORDER_DEP',

    ASSIGN_ORDER: 'ASSIGN_ORDER',
    REJECT_ORDER: 'REJECT_ORDER',
    REVOKE_ORDER: 'REVOKE_ORDER',


    WORKER_ACCEPT_ORDER: 'WORKER_ACCEPT_ORDER',
    WORKER_IN_WAY: 'WORKER_IN_WAY',
    WORKER_WORKING: 'WORKER_WORKING',
    WORKER_PERFORM: 'WORKER_PERFORM',
    WORKER_FINISHING: 'WORKER_FINISHING',

    EDIT_ORDER_DESCRIPTION: 'EDIT_ORDER_DESCRIPTION',
    EDIT_ORDER_IS_PROFILE: 'EDIT_ORDER_IS_PROFILE',
    EDIT_ORDER_WORKER: 'EDIT_ORDER_WORKER',
    EDIT_COMPLETION_DATA: 'EDIT_COMPLETION_DATA',

    COMPLETE_ORDER: 'COMPLETE_ORDER',

    RESET_ORDER: 'RESET_ORDER',
    ACTIVATE_USER: 'ACTIVATE_USER',

    DELETE_ORDER: 'DELETE_ORDER',
    RECOVERY_ORDER: 'RECOVERY_ORDER',

    //==========office
    HAND_OVER: 'HAND_OVER',
    RETURN_FROM_OFFICE: 'RETURN_FROM_OFFICE',

    CREATE_CATEGORY: 'CREATE_CATEGORY',
    EDIT_CATEGORY: 'EDIT_CATEGORY',
    DELETE_CATEGORY: 'DELETE_CATEGORY',

    CREATE_EXPENSE: 'CREATE_EXPENSE',
    EDIT_EXPENSE: 'EDIT_EXPENSE',
    DELETE_EXPENSE: 'DELETE_EXPENSE',

    CREATE_REVENUE: 'CREATE_REVENUE',
    DELETE_REVENUE: 'DELETE_REVENUE',
    // ================

    DELETE_IMAGE: 'DELETE_IMAGE', 

    CREATE_USER: 'CREATE_USER',
    EDIT_USER: 'EDIT_USER',
    DELETE_USER: 'DELETE_USER',
    RECOVERY_USER: 'RECOVERY_USER',

    CREATE_PROMOTER: 'CREATE_PROMOTER',
    EDIT_PROMOTER: 'EDIT_PROMOTER',
    ASSIGN_ROUTE: 'ASSIGN_ROUTE',
    REVOKE_ROUTE: 'REVOKE_ROUTE',

    ROUTE_STARTED: 'ROUTE_STARTED', 
    ROUTE_PROGRESS_UPDATED: 'ROUTE_PROGRESS_UPDATED',
    CHECK_ROUTE_ADDRESS: 'CHECK_ROUTE_ADDRESS',
    ROUTE_READY_TO_CHECK: 'ROUTE_READY_TO_CHECK',
    REJECT_PORCH: 'REJECT_PORCH',
    DELETE_ROUTE_PHOTO: 'DELETE_ROUTE_PHOTO',
    FINISH_ROUTE: 'FINISH_ROUTE',
    RETURN_FLYERS: 'RETURN_FLYERS',

    CHECK_ROUTE: 'CHECK_ROUTE',
    PAY_ROUTE: 'PAY_ROUTE',
    UNLOCK_ROUTE: 'UNLOCK_ROUTE',
    SET_ROUTE_COMMENT: 'SET_ROUTE_COMMENT',
    EDIT_FINISHED_ROUTE: 'EDIT_FINISHED_ROUTE',
    DELETE_PROMOTER: 'DELETE_PROMOTER',
    RECOVERY_PROMOTER: 'RECOVERY_PROMOTER',
    SET_ROUTE_LOCKS: 'SET_ROUTE_LOCKS',
    EDIT_ACTIVE_ROUTE: 'EDIT_ACTIVE_ROUTE',
    CREATE_FINISHED_ROUTE: 'CREATE_FINISHED_ROUTE',
    ADD_SPREAD_FLYERS: 'ADD_SPREAD_FLYERS',
    EDIT_ADVERT_PLAN: 'EDIT_ADVERT_PLAN',
};

//client messages
export const CLIENT_NOTS = {
    EMPTY_FIELD: 'EMPTY_FIELD',
    NO_ORDER_CHANGES: 'NO_ORDER_CHANGES',

    CREATE_ORDER: 'CREATE_ORDER_CL',
    CREATE_ORDER_DEP: 'CREATE_ORDER_DEP_CL',
    ORDER_EVENTS: 'ORDER_EVENTS_CL',

    ASSIGN_ORDER: 'ASSIGN_ORDER_CL',
    REVOKE_ORDER: 'REVOKE_ORDER_CL',

    COMPLETE_ORDER: 'COMPLETE_ORDER_CL',

    EDIT_ORDER_DESCRIPTION: 'EDIT_ORDER_DESCRIPTION_CL',
    EDIT_ORDER_IS_PROFILE: 'EDIT_ORDER_IS_PROFILE_CL',
    EDIT_ORDER_WORKER: 'EDIT_ORDER_WORKER_CL',
    EDIT_COMPLETION_DATA: 'EDIT_COMPLETION_DATA_CL',

    RESET_ORDER: 'RESET_ORDER_CL',

    DELETE_ORDER: 'DELETE_ORDER_CL',
    RECOVERY_ORDER: 'RECOVERY_ORDER_CL',

    //========office
    HAND_OVER: 'HAND_OVER_CL',
    RETURN_FROM_OFFICE: 'RETURN_FROM_OFFICE_CL',

    CREATE_CATEGORY: 'CREATE_CATEGORY_CL',
    EDIT_CATEGORY: 'EDIT_CATEGORY_CL',
    DELETE_CATEGORY: 'DELETE_CATEGORY_CL',

    CREATE_EXPENSE: 'CREATE_EXPENSE_CL',
    EDIT_EXPENSE: 'EDIT_EXPENSE_CL',
    DELETE_EXPENSE: 'DELETE_EXPENSE_CL',

    CREATE_REVENUE: 'CREATE_REVENUE_CL',
    DELETE_REVENUE: 'DELETE_REVENUE_CL',
    //===========

    IMAGE_ERROR: 'IMAGE_ERROR_CL',
    VIDEO_ERROR: 'VIDEO_ERROR_CL',
    DELETE_IMAGE: 'DELETE_IMAGE_CL',

    CREATE_USER: 'CREATE_USER_CL',
    EDIT_USER: 'EDIT_USER_CL',
    DELETE_USER: 'DELETE_USER_CL',
    RECOVERY_USER: 'RECOVERY_USER_CL',

    UPDATE_SETTINGS: 'UPDATE_SETTINGS_CL',

    CREATE_PROMOTER: 'CREATE_PROMOTER_CL',
    EDIT_PROMOTER: 'EDIT_PROMOTER_CL',
    ASSIGN_ROUTE: 'ASSIGN_ROUTE_CL',
    REVOKE_ROUTE: 'REVOKE_ROUTE_CL',
    ROUTE_READY_TO_CHECK: 'ROUTE_READY_TO_CHECK_CL',
    CHECK_ROUTE_ADDRESS: 'CHECK_ROUTE_ADDRESS_CL',
    REJECT_PORCH: 'REJECT_PORCH_CL',
    DELETE_ROUTE_PHOTO: 'DELETE_ROUTE_PHOTO_CL',
    FINISH_ROUTE: 'FINISH_ROUTE_CL',
    RETURN_FLYERS: 'RETURN_FLYERS_CL',

    CHECK_ROUTE: 'CHECK_ROUTE_CL',
    PAY_ROUTE: 'PAY_ROUTE_CL',
    SET_ROUTE_COMMENT: 'SET_ROUTE_COMMENT_CL',
    EDIT_FINISHED_ROUTE: 'EDIT_FINISHED_ROUTE_CL',
    DELETE_PROMOTER: 'DELETE_PROMOTER_CL',
    RECOVERY_PROMOTER: 'RECOVERY_PROMOTER_CL',
    SET_ROUTE_LOCKS: 'SET_ROUTE_LOCKS_CL',
    EDIT_ACTIVE_ROUTE: 'EDIT_ACTIVE_ROUTE_CL',
    CREATE_FINISHED_ROUTE: 'CREATE_FINISHED_ROUTE_CL',
    ADD_SPREAD_FLYERS: 'ADD_SPREAD_FLYERS_CL',
    EDIT_ADVERT_PLAN: 'EDIT_ADVERT_PLAN_CL',

    UPDATE_ORDER_COLORS: 'UPDATE_ORDER_COLORS',
    UPDATE_THEME_COLORS: 'UPDATE_THEME_COLORS',
}

const generateSSENotifyContent = ({data, info}) => {
    let title = null;
    let text = null;
    const fullname = info.initiator?.fullname || 'Кто-то';
    switch(info.action) {
        case SERVER_NOTS.CREATE_ORDER: {
            title = 'Создание заявки';
            text = `${fullname} создал заявку id${data.order.id}.`;
            break;
        }
        case SERVER_NOTS.CREATE_ORDER_DEP: {
            title = 'Создание гарантии/повтора';
            text = `${fullname} создал гарантию id${data.order.id}.`;
            break;
        }
        case SERVER_NOTS.ASSIGN_ORDER: {
            title = 'Отправка заявки';
            text =`${fullname} отправил заявку id${data.order.id} мастеру ${data.worker.fullname}.`;
            break;
        }
        case SERVER_NOTS.REJECT_ORDER: {

            title = 'Возвращение заявки';
            text = `Мастер ${data.worker.fullname} не успел принять заявку id${data.order.id}.`;
            break;
        }
        case SERVER_NOTS.REVOKE_ORDER: {
            title = 'Отзыв заявки';
            text = `Заявка id${data.order.id} была отозвана.`;
            break;
        }

        case SERVER_NOTS.WORKER_ACCEPT_ORDER: {
            title = 'Заявка принята';
            text = `Мастер ${data.worker.fullname} принял заявку id${data.order.id}.`
            break;
        }
        case SERVER_NOTS.WORKER_IN_WAY: {
            title = 'Мастер в пути';
            text = `Мастер ${data.worker.fullname} в пути (заявка id${data.order.id}).`
            break;
        }
        case SERVER_NOTS.WORKER_WORKING: {
            title = 'Мастер в работе';
            text = `Мастер ${data.worker.fullname} начал работу по заявке id${data.order.id}.`
            break;
        }
        case SERVER_NOTS.WORKER_PERFORM: {
            title = 'Заявка подходит к концу';
            text = `Мастер ${data.worker.fullname} приступил к оформлению заявки id${data.order.id}.`
            break;
        }
        case SERVER_NOTS.WORKER_FINISHING: {
            title = 'Заявка завершена';
            text = `Мастер ${data.worker.fullname} завершил заявку id${data.order.id} со статусом ${data.order.orderStatus.name}.`
            break;
        }

        case SERVER_NOTS.COMPLETE_ORDER: {
            title = 'Заявка завершена';
            text = `Заявка id${data.order.id} была завершена со статусом ${data.order.orderStatus.name}.`
            break;
        }

        case SERVER_NOTS.EDIT_ORDER_DESCRIPTION: {
            title = 'Заявка отредактирована';
            text = `${fullname} изменил описание заявки id${data.order.id}.`
            break;
        }
        case SERVER_NOTS.EDIT_ORDER_IS_PROFILE: {
            title = 'Заявка отредактирована';
            const isProfile = data.order.isProfile ? 'профиль' : 'непрофиль';
            text = `${fullname} изменил изменил заявку id${data.order.id} на ${isProfile}.`
            break;
        }
        case SERVER_NOTS.EDIT_ORDER_WORKER: {
            title = 'Изменение мастера';
            text = `${fullname} поменял мастера в заявке id${data.order.id} на ${data.newWorker.fullname}.`;
            break;
        }
        case SERVER_NOTS.EDIT_COMPLETION_DATA: {
            title = 'Редактирование результатов заявки';
            text = `${fullname} изменил результаты заявки id${data.order.id}.`;
            break;
        }

        case SERVER_NOTS.RESET_ORDER: {
            title = 'Сброс заявки';
            text = `${fullname} сбросил результаты заявки id${data.order.id}.`;
            break;
        }

        case SERVER_NOTS.ACTIVATE_USER: {
            title = 'Пользователь активирован';
            text = `Пользователь ${data.worker.fullname} активировал свой аккаунт.`;
            break;
        }

        case SERVER_NOTS.DELETE_ORDER: {
            title = 'Удаление заявки';
            text = `${fullname} удалил заявку id${data.order.id}.`;
            break;
        }
        case SERVER_NOTS.RECOVERY_ORDER: {
            title = 'Восстановление заявки';
            text = `${fullname} восстановил заявку id${data.order.id} из корзины.`;
            break;
        }


        case SERVER_NOTS.HAND_OVER: {
            title = 'Сдача заявки в кассу';
            text = `${fullname} сдал в кассу заявку id${data.order.id}`;
            break;
        }
        case SERVER_NOTS.RETURN_FROM_OFFICE: {
            title = 'Возвращение заявки из кассы';
            text = `${fullname} вернул из кассы заявку id${data.order.id}.`;
            break;
        }

        case SERVER_NOTS.CREATE_CATEGORY: {
            title = 'Создание категории';
            text = `${fullname} создал в кассе категорию ${data.category.name}.`;
            break;
        }
        case SERVER_NOTS.EDIT_CATEGORY: {
            title = 'Редактирование категории';
            text = `${fullname} отредактировал в кассе категорию ${data.category.name}.`;
            break;
        }
        case SERVER_NOTS.DELETE_CATEGORY: {
            title = 'Удаление категории';
            text = `${fullname} удалил категорию ${data.category.name} из кассы.`;
            break;
        }

        case SERVER_NOTS.CREATE_EXPENSE: {
            title = 'Создание расхода';
            text = `${fullname} создал расход на сумму ${data.expense.amount} (${data.expense.category.name})`;
            break;
        }
        case SERVER_NOTS.EDIT_EXPENSE: {
            title = 'Редактирование расхода';
            text = `${fullname} отредактировал расход`;
            break;
        }
        case SERVER_NOTS.DELETE_EXPENSE: {
            title = 'Удаление расхода';
            text = `${fullname} удалил расход`;
            break;
        }

        case SERVER_NOTS.CREATE_REVENUE: {
            title = 'Создание дохода';
            text = `${fullname} создал доход на сумму ${data.revenue.amount} (${data.revenue.comment})`;
            break;
        }
        case SERVER_NOTS.DELETE_REVENUE: {
            title = 'Удаление дохода';
            text = `${fullname} удалил доход`;
            break;
        }


        case SERVER_NOTS.CREATE_USER: {
            title = 'Создание пользователя';
            text = `${fullname} создал пользователя ${data.user.fullname}.`;
            break;
        }

        case CLIENT_NOTS.EDIT_USER: {
            title = 'Редактирование пользователя';
            text =  `${fullname} отредактировал пользователя ${data.user.fullname}.`;
            break;
        }

        case SERVER_NOTS.DELETE_USER: {
            title = 'Удаление пользователя';
            text = `${fullname} удалил пользователя ${data.user.fullname}.`;
            break;
        }
        case SERVER_NOTS.RECOVERY_USER: {
            title = 'Восстановление пользователя';
            text = `${fullname} удалил пользователя ${data.user.fullname}.`;
            break;
        }

        case SERVER_NOTS.CREATE_PROMOTER: {
            title = 'Создание промоутера';
            text = `${fullname} создал промоутера ${data.promoter.fullname}.`;
            break;
        }
        case SERVER_NOTS.EDIT_PROMOTER: {
            title = 'Редактирование промоутера';
            text = `${fullname} отредактировал промоутера ${data.promoter.fullname}.`;
            break;
        }
        case SERVER_NOTS.DELETE_PROMOTER: {
            title = 'Удаление промоутера';
            text = `${fullname} удалил промоутера ${data.promoter.fullname}.`;
            break;
        }
        case SERVER_NOTS.RECOVERY_PROMOTER: {
            title = 'Восстановление промоутера';
            text = `${fullname} восстановил промоутера ${data.promoter.fullname}.`;
            break;
        }

        case SERVER_NOTS.ASSIGN_ROUTE: {
            title = 'Назначение маршрута';
            text = `${fullname} назначил маршрут #${data.route.id} промоутеру ${data.promoter.fullname}.`;
            break;
        }
        case SERVER_NOTS.REVOKE_ROUTE: {
            title = 'Отзыв маршрута';
            text = `${fullname} отозвал промоутера ${data.promoter.fullname} с маршрута #${data.route.id}.`;
            break;
        }

        case SERVER_NOTS.ROUTE_STARTED: {
            title = 'Маршрут начат';
            text = `Промоутер ${data.promoter.fullname} работает с маршрутом #${data.route.id}.`
            break;
        }
        case SERVER_NOTS.ROUTE_READY_TO_CHECK: {
            title = !data.isRevision ? 'Маршрут готов к проверке' : 'Маршрут отправлен на доработку';
            text = !data.isRevision ? `Промоутер ${data.promoter.fullname} отправил маршрут на проверку.` : `${fullname} отправил маршрут промоутера ${data.promoter.fullname} на доработку`
            break;
        }
        case SERVER_NOTS.FINISH_ROUTE: {
            title = 'Маршрут завершен';
            text = `Маршрут #${data.route.id} был завершен.`;
            break;
        }
        case SERVER_NOTS.RETURN_FLYERS: {
            title = 'Возвращение листовок';
            text = `${fullname} вернул листовки за маршрут ${data.route.id}`;
            break;
        }
        case SERVER_NOTS.UNLOCK_ROUTE: {
            title = 'Разблокировка маршрута';
            text = `Маршрут #${data.route.id} разблокирован и готов к назначению.`;
            break;
        }
        case SERVER_NOTS.EDIT_FINISHED_ROUTE: {
            title = 'Редактирование маршрута';
            text = `${fullname} отредактировал данные о маршруте`;
            break;
        }

        default: throw new Error('Необработанный switch в уведомлениях');
    }
    return {title, text};
}

const generateClientNotifyContent = (data, action) => {
    let title = null;
    let text = null;
    const success = data.isOkay;
    switch(action) {

        case CLIENT_NOTS.CREATE_ORDER: {
            title = 'Создание заявки';
            text = success ? `Заявка id${data.order.id} успешно создана.` : data.message;
            break;
        }
        case CLIENT_NOTS.CREATE_ORDER_DEP: {
            title = 'Создание гарантии/повтора';
            text = success ? `Заявка id${data.order.id} успешно создана.` : data.message;
            break;
        }
        case CLIENT_NOTS.ORDER_EVENTS: {
            title = 'Загрузка истории заявки';
            text = success ? `Это текст не используется.` : data.message;
            break;
        }
        case CLIENT_NOTS.EMPTY_FIELD: {
            title = 'Ошибка в заявке';
            text = `Не заполнены поля (${data.message})`;
            break;
        }
        case CLIENT_NOTS.NO_ORDER_CHANGES: {
            title = 'Редактирование заявки';
            text = `Изменений не обнаружено`;
            break;
        }
        case CLIENT_NOTS.ASSIGN_ORDER: {
            title = 'Отправка заявки';
            text = success
                ? `Заявка id${data.order.id} успешно отправлена мастеру ${data.worker.fullname}`
                : data.message;
            break;
        }
        case CLIENT_NOTS.REVOKE_ORDER: {
            title = 'Отзыв заявки';
            text = success ? `Заявка id${data.order.id} отозвана.` : data.message;
            break;
        }
        case CLIENT_NOTS.COMPLETE_ORDER: {
            title = 'Завершение заявки';
            text = success ? `Заявка id${data.order.id} была завершена со статусом ${data.order.orderStatus.name}.` : data.message;
            break;
        }

        case CLIENT_NOTS.EDIT_ORDER_DESCRIPTION: {
            title = 'Редактирование заявки';
            text = success ? `Описание заявки id${data.order.id} успешно отредактировано.` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_ORDER_IS_PROFILE: {
            title = 'Редактирование заявки';
            const isProfile = success ? data.order.isProfile ? 'профиль' : 'непрофиль' : null;
            text = success ? `Заявка id${data.order.id} была изменена на ${isProfile}.` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_ORDER_WORKER: {
            title = 'Редактирование заявки';
            text = success ? `Мастер в заявке id${data.order.id} успешно изменен.` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_COMPLETION_DATA: {
            title = 'Редактирование заявки';
            text = success ? `Результаты заявки id${data.order.id} успешно отредактированы.` : data.message;
            break;
        }

        case CLIENT_NOTS.RESET_ORDER: {
            title = 'Сброс заявки';
            text = success ? `Результаты заявки id${data.order.id} были сброшены.` : data.message;
            break;
        }

        case CLIENT_NOTS.DELETE_ORDER: {
            title = 'Удаление заявки';
            text = success ? `Заявка id${data.order.id} была удалена.` : data.message;
            break;
        }
        case CLIENT_NOTS.RECOVERY_ORDER: {
            title = 'Восстановление заявки';
            text = success ? `Заявка id${data.order.id} была восстановлена из корзины.` : data.message;
            break;
        }

        case CLIENT_NOTS.HAND_OVER: {
            title = 'Сдача в кассу';
            text = success ? `Деньги по выбранным заявкам сданы в кассу.` : `Некоторые заявки сдать не удалось:\n${data.message}`;
            break;
        }
        case CLIENT_NOTS.RETURN_FROM_OFFICE: {
            title = 'Возвращение из кассы';
            text = success ? `Выбранные заявки были возвращены из кассы.` : data.message;
            break;
        }

        case CLIENT_NOTS.CREATE_CATEGORY: {
            title = 'Создание категории';
            text = success ? `Категория создана` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_CATEGORY: {
            title = 'Редактирование категории';
            text = success ? `Категория отредактирована` : data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_CATEGORY: {
            title = 'Удаление категории';
            text = success ? `Категория удалена\nВсе принадлежащие данной категории расходы перенесены в "Другое"` : data.message;
            break;
        }

        case CLIENT_NOTS.CREATE_EXPENSE: {
            title = 'Создание расхода';
            text = success ? `Создан расход на сумму ${data.expense.amount.toLocaleString('fr-FR')}₽ (${data.expense.category.name})` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_EXPENSE: {
            title = 'Редактирование расхода';
            text = success ? `Расход отредактирован` : data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_EXPENSE: {
            title = 'Удаление расхода';
            text = success ? `Расход удален` : data.message;
            break;
        }

        case CLIENT_NOTS.CREATE_REVENUE: {
            title = 'Создание дохода';
            text = success ? `Создан доход на сумму ${data.revenue.amount.toLocaleString('fr-FR')}₽ (${data.revenue.comment})` : data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_REVENUE: {
            title = 'Удаление дохода';
            text = success ? `доход удален` : data.message;
            break;
        }

        case CLIENT_NOTS.IMAGE_ERROR: {
            title = 'Ошибка при загрузке фотографии';
            text = data.message;
            break;
        }
        case CLIENT_NOTS.VIDEO_ERROR: {
            title = 'Ошибка при загрузке видео';
            text = data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_IMAGE: {
            title = 'Удаление фотографии';
            text =  success ? `Фотография успешно удалена` : data.message;
            break;
        }

        case CLIENT_NOTS.CREATE_USER: {
            title = 'Создание пользователя';
            text =  success ? `Пользователь ${data.user.fullname} успешно добавлен` : data.message;
            break;
        }

        case CLIENT_NOTS.EDIT_USER: {
            title = 'Редактирование пользователя';
            text =  success ? `Пользователь ${data.user.fullname} успешно отредактирован` : data.message;
            break;
        }

        case CLIENT_NOTS.DELETE_USER: {
            title = 'Удаление пользователя';
            text =  success ? `Пользователь ${data.user.fullname} удалён` : data.message;
            break;
        }
        case CLIENT_NOTS.RECOVERY_USER: {
            title = 'Восстановление пользователя';
            text =  success ? `Пользователь ${data.user.fullname} восстановлен` : data.message;
            break;
        }

        case CLIENT_NOTS.UPDATE_SETTINGS: {
            title = 'Обновление настроек';
            text =  success ? `Настройки успешно обновлены` : data.message;
            break;
        }

        case CLIENT_NOTS.CREATE_PROMOTER: {
            title = 'Создание промоутера';
            text =  success ? `Промоутер ${data.promoter.fullname} успешно добавлен` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_PROMOTER: {
            title = 'Редактирование промоутера';
            text =  success ? `Промоутер ${data.promoter.fullname} успешно отредактирован` : data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_PROMOTER: {
            title = 'Удаление промоутера';
            text =  success ? `Промоутер ${data.promoter.fullname} успешно удалён` : data.message;
            break;
        }
        case CLIENT_NOTS.RECOVERY_PROMOTER: {
            title = 'Восстановление промоутера';
            text =  success ? `Промоутер ${data.promoter.fullname} успешно восстановлен` : data.message;
            break;
        }

        case CLIENT_NOTS.ASSIGN_ROUTE: {
            title = 'Назначение маршрута';
            text =  success ? `Маршрут ${data.route.id} успешно назначен промоутеру ${data.promoter.fullname}` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_ACTIVE_ROUTE: {
            title = 'Редактирование маршрута';
            text =  success ? `Маршрут успешно отредактирован` : data.message;
            break;
        }
        case CLIENT_NOTS.REVOKE_ROUTE: {
            title = 'Отзыв маршрута';
            text =  success ? `Промоутер ${data.promoter.fullname} успешно отозван с маршрута #${data.route.id}` : data.message;
            break;
        }
        case CLIENT_NOTS.CHECK_ROUTE_ADDRESS: {
            title = 'Проверка дома/подъезда';
            text =  success ? `Дом/подъезд проверен` : data.message;
            break;
        }
        case CLIENT_NOTS.ROUTE_READY_TO_CHECK: {
            title = !data.isRevision ? 'Маршрут готов к проверке' : 'Маршрут отправлен на доработку';
            text =  success ? 
                    !data.isRevision ? 
                        `Маршрут готов к проверке. Теперь промоутер не сможет изменять или удалять контент`
                        : 'Маршрут отправлен на доработку. Промоутер сможет изменять контент только в отклоненных или ранее непосещенных подъездах'
                    : data.message;
            break;
        }
        case CLIENT_NOTS.REJECT_PORCH: {
            title = 'Отклонение подъезда';
            text =  success ? `Подъезд отклонен.` : data.message;
            break;
        }
        case CLIENT_NOTS.DELETE_ROUTE_PHOTO: {
            title = 'Удаление фото подъезда';
            text =  success ? `Фотография успешно удалена` : data.message;
            break;
        }
        case CLIENT_NOTS.FINISH_ROUTE: {
            title = 'Завершение маршрута';
            text =  success ? `Маршрут завершен` : data.message;
            break;
        }

        case CLIENT_NOTS.RETURN_FLYERS: {
            title = 'Возвращение листовок';
            text =  success ? `Листовки успешно возвращены` : data.message;
            break;
        }

        case CLIENT_NOTS.CHECK_ROUTE: {
            title = 'Проверка маршрута';
            text =  success ? `Маршрут проверен. Теперь можно рассчитаться за него` : data.message;
            break;
        }
        case CLIENT_NOTS.PAY_ROUTE: {
            title = 'Оплата маршрута';
            text =  success ? `Маршрут оплачен` : data.message;
            break;
        }
        case CLIENT_NOTS.SET_ROUTE_COMMENT: {
            title = 'Редактирование комментария';
            text =  success ? `Комментарий к маршруту успешно изменен` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_FINISHED_ROUTE: {
            title = 'Редактирование маршрута';
            text =  success ? `Маршрут успешно отредактирован` : data.message;
            break;
        }
        case CLIENT_NOTS.SET_ROUTE_LOCKS: {
            title = 'Редактирование блокировок';
            text =  success ? `Блокировке успешно отредактированы` : data.message;
            break;
        }
        case CLIENT_NOTS.CREATE_FINISHED_ROUTE: {
            title = 'Создание завершенного маршрута';
            text =  success ? `Информация по маршруту успешно добавлена` : data.message;
            break;
        }
        case CLIENT_NOTS.ADD_SPREAD_FLYERS: {
            title = 'Добавление листовок';
            text =  success ? `Разнесенные листовки успешно добавлены.` : data.message;
            break;
        }
        case CLIENT_NOTS.EDIT_ADVERT_PLAN: {
            title = 'Редактирование собеседований';
            text =  success ? `Успех.` : data.message;
            break;
        }
        case CLIENT_NOTS.UPDATE_ORDER_COLORS: {
            title = 'Изменение цветов заказов';
            text = success ? `Настройки успешно сохранены.` : data.message;
            break;
        }
        case CLIENT_NOTS.UPDATE_THEME_COLORS: {
            title = 'Изменение темы';
            text = success ? `Настройки темы успешно сохранены.` : data.message;
            break;
        }

        default: throw new Error('Необработанный switch в уведомлениях');
    }
    return {title, text};
}
const setUpdate = (thunkAPI, {data, info}) => {
    switch(info.action) {
        case SERVER_NOTS.CREATE_ORDER:
        case SERVER_NOTS.CREATE_ORDER_DEP: {
            data.order && thunkAPI.dispatch(insertNewOrder(data.order));
            data.dependencies && thunkAPI.dispatch(updateDeps(data.dependencies));
            return;
        }
        case SERVER_NOTS.ASSIGN_ORDER:
        case SERVER_NOTS.REJECT_ORDER:
        case SERVER_NOTS.REVOKE_ORDER: 
        
        case SERVER_NOTS.WORKER_ACCEPT_ORDER:
        case SERVER_NOTS.WORKER_IN_WAY:
        case SERVER_NOTS.WORKER_WORKING:
        case SERVER_NOTS.WORKER_PERFORM:
        case SERVER_NOTS.WORKER_FINISHING:
        case SERVER_NOTS.RESET_ORDER:
        case SERVER_NOTS.RECOVERY_ORDER:
        case SERVER_NOTS.ACTIVATE_USER:
        case SERVER_NOTS.COMPLETE_ORDER: {
            data.order && thunkAPI.dispatch(updateOrder(data.order));
            data.worker && thunkAPI.dispatch(updateUser(data.worker));
            break;
        }
        case SERVER_NOTS.DELETE_ORDER: {
            data.order && thunkAPI.dispatch(dropOrder(data.order._id));
            break;
        }
        case SERVER_NOTS.EDIT_ORDER_DESCRIPTION:
        case SERVER_NOTS.EDIT_ORDER_IS_PROFILE:
        case SERVER_NOTS.EDIT_ORDER_WORKER:
        case SERVER_NOTS.EDIT_COMPLETION_DATA: {
            data.order && thunkAPI.dispatch(updateOrder(data.order));
            data.worker && thunkAPI.dispatch(updateUser(data.worker));
            data.workers?.prev && thunkAPI.dispatch(updateUser(data.workers.prev));
            data.workers?.new && thunkAPI.dispatch(updateUser(data.workers.new));
            data.dependencies && thunkAPI.dispatch(updateUser(data.dependencies));
            break;
        }
        case SERVER_NOTS.HAND_OVER: {
            data.order && thunkAPI.dispatch(updateOrder(data.order));
            data.revenue && thunkAPI.dispatch(setRevenues([data.revenue]));
            data.balances && thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }
        case SERVER_NOTS.RETURN_FROM_OFFICE: {
            data.order && thunkAPI.dispatch(updateOrder(data.order));
            data.revenue && thunkAPI.dispatch(deleteRevenue(data.revenue._id));
            data.balances && thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }
        case SERVER_NOTS.CREATE_CATEGORY: {
            data.category && thunkAPI.dispatch(addCategory(data.category));
            break;
        }
        case SERVER_NOTS.EDIT_CATEGORY: {
            data.category && thunkAPI.dispatch(editCategory(data.category));
            data.category && thunkAPI.dispatch(updateExpensesCategory(data.category));
            break;
        }
        case SERVER_NOTS.DELETE_CATEGORY: {
            data.category && thunkAPI.dispatch(deleteCategory(data.category._id));
            data.expenses && thunkAPI.dispatch(updateExpenses(data.expenses));
            // const categoryList = thunkAPI.getState().settings.expenseCategories;
            //Получаем все траты текущей категории и дропаем
            const expenseList = thunkAPI.getState().office.expenses.filter((exp) => exp.category._id === data.category._id);
            expenseList.length && thunkAPI.dispatch(dropExpenses(expenseList.map((exp) => exp._id)));
            break;
        }

        case SERVER_NOTS.CREATE_EXPENSE: {
            thunkAPI.dispatch(setExpenses([data.expense]));
            thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }
        case SERVER_NOTS.EDIT_EXPENSE: {
            thunkAPI.dispatch(updateExpense(data.expense));
            thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }
        case SERVER_NOTS.DELETE_EXPENSE: {
            thunkAPI.dispatch(dropExpense(data.expense._id));
            thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }

        case SERVER_NOTS.CREATE_REVENUE: {
            thunkAPI.dispatch(setRevenues([data.revenue]));
            thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }

        case SERVER_NOTS.DELETE_REVENUE: {
            thunkAPI.dispatch(deleteRevenue(data.revenue._id));
            thunkAPI.dispatch(updateBalances(data.balances));
            break;
        }
        case SERVER_NOTS.DELETE_IMAGE: {
            thunkAPI.dispatch(dropImage({fileName: data.fileName, type: data.type}));
            data.orderId && thunkAPI.dispatch(dropOrderImage({orderId: data.orderId, fileName: data.fileName}));
            data.userId && thunkAPI.dispatch(dropUserDocument({userId: data.userId, fileName: data.fileName}));
            break;
        }
        case SERVER_NOTS.CREATE_USER: {
            thunkAPI.dispatch(addUser(data.user));
            thunkAPI.dispatch(updateAvailableUsers(data.availableUsers));
            data.creator && thunkAPI.dispatch(updateUser(data.creator));
            break;
        }
        case SERVER_NOTS.EDIT_USER: {
            thunkAPI.dispatch(updateUser(data.user));
        }
        case SERVER_NOTS.DELETE_USER: {
            thunkAPI.dispatch(setDeletingUser({_id: data.user._id, deleted: true}));
            break;
        }
        case SERVER_NOTS.RECOVERY_USER: {
            thunkAPI.dispatch(setDeletingUser({_id: data.user._id, deleted: false}));
            break;
        }

        case SERVER_NOTS.CREATE_PROMOTER: {
            thunkAPI.dispatch(pushPromoter(data.promoter));
            break;
        }
        case SERVER_NOTS.EDIT_PROMOTER: {
            thunkAPI.dispatch(updatePromoter(data.promoter));
            break;
        }
        case SERVER_NOTS.DELETE_PROMOTER: {
            thunkAPI.dispatch(setPromoterDeleted(data.promoter._id));
            break;
        }
        case SERVER_NOTS.RECOVERY_PROMOTER: {
            thunkAPI.dispatch(setPromoterRecovered(data.promoter._id));
            break;
        }
        case SERVER_NOTS.ASSIGN_ROUTE:
        case SERVER_NOTS.EDIT_ACTIVE_ROUTE:
        case SERVER_NOTS.REVOKE_ROUTE: {
            data.route && thunkAPI.dispatch(updateRoute(data.route));
            data.newRoute && thunkAPI.dispatch(updateRoute(data.newRoute));
            thunkAPI.dispatch(updatePromoter(data.promoter));
            break;
        }

        case SERVER_NOTS.ROUTE_STARTED: {
            thunkAPI.dispatch(updateRouteStarted(data));
            break;
        }
        case SERVER_NOTS.ROUTE_PROGRESS_UPDATED:
        case SERVER_NOTS.REJECT_PORCH:
        case SERVER_NOTS.DELETE_ROUTE_PHOTO: {
            thunkAPI.dispatch(updateRouteProgress(data));
            break;
        }
        case SERVER_NOTS.CHECK_ROUTE_ADDRESS: {
            if (data.porchId !== null) {    //Полный отчет
                thunkAPI.dispatch(setPorchChecked(data))
            } else {
                thunkAPI.dispatch(setAddressChecked(data))
            }
            break;
        }
        case SERVER_NOTS.ROUTE_READY_TO_CHECK: {
            thunkAPI.dispatch(setRouteReadyToCheck(data))
            break;
        }
        case SERVER_NOTS.FINISH_ROUTE: {
            thunkAPI.dispatch(setRouteFinished(data));
            thunkAPI.dispatch(updatePromoter(data.promoter));
            data.newRoute && thunkAPI.dispatch(updateRoute(data.newRoute));
            const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
            thunkAPI.dispatch(pushFinishedRoute({route: data.finishedRoute, mainUTCStr}));
            break;
        }
        case SERVER_NOTS.EDIT_FINISHED_ROUTE: {
            const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
            thunkAPI.dispatch(updateFinishedRoute({route: data.finishedRoute, mainUTCStr}));
            break;
        }
        case SERVER_NOTS.CHECK_ROUTE: {
            thunkAPI.dispatch(setRouteChecked(data.finishId));
            break;
        }
        case SERVER_NOTS.UNLOCK_ROUTE: {
            thunkAPI.dispatch(updateRouteLocks(data));
            break;
        }
        case SERVER_NOTS.SET_ROUTE_LOCKS: {
            thunkAPI.dispatch(updateRouteLocks(data.route));
            break;
        }
        case SERVER_NOTS.RETURN_FLYERS:
        case SERVER_NOTS.SET_ROUTE_COMMENT: {
            data.promoter && thunkAPI.dispatch(updatePromoter(data.promoter))
            const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
            data.finishedRoute && thunkAPI.dispatch(updateFinishedRoute({route: data.finishedRoute, mainUTCStr}))
            break;
        }
        case SERVER_NOTS.CREATE_FINISHED_ROUTE: {
            const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
            thunkAPI.dispatch(pushFinishedRoute({route: data.finishedRoute, mainUTCStr}));
            break;
        }
        case SERVER_NOTS.ADD_SPREAD_FLYERS: {
            thunkAPI.dispatch(pushAdditionalSpreadFlyers(data.spreadFlyers));
            break;
        }
        default: {
        }
    }
}

export const getClientNotify = createAsyncThunk('notify/getClientNotify', async ({data, action}, thunkAPI) => {
    const {title, text} = generateClientNotifyContent(data, action);
    const success = data.isOkay;
    const id = Date.now();
    thunkAPI.dispatch(addNotify({ title, text, success, id, action }));
    setTimeout(() => thunkAPI.dispatch(hideNotify(id)), NOTIFY_TIMEOUT);
});

export const getSSENotify = createAsyncThunk(
    'notify/getSSENotify',
    async (bodyData, thunkAPI) => {
        setUpdate(thunkAPI, bodyData);
        const {title, text} = generateSSENotifyContent(bodyData);

        const {success, action} = bodyData.info;
        const id = Date.now();
        thunkAPI.dispatch(addNotify({ title, text, success, id, action }));
        setTimeout(() => thunkAPI.dispatch(hideNotify(id)), SSE_NOTIFY_TIMEOUT);
    },
);

const notifySlice = createSlice({
    name: 'notify',
    initialState,
    reducers: {
        addNotify(state, action) {
            state.list = [...state.list, {...action.payload, isViewed: false}]
        },
        hideNotify(state, { payload: id }) {
            state.list = state.list.map((notify) =>
                notify.id === id ? { ...notify, isViewed: true } : notify,
            );
        },
    },
});

export const { addNotify, hideNotify } = notifySlice.actions;

export default notifySlice.reducer;
